export class DataSopralluogoFase1DTO {
    dataPianificata!: Date;
   
  }
  